import * as React from 'react';
import { SearchResultList } from '../../components/SearchResultList';
import { SearchResultItemContainer } from '../SearchResultItem';
import { useSelector } from 'react-redux';
import { selectBuilders } from '../../selectors/builders';
import { selectLoading } from '../../selectors/loading';
import { Preloader } from '../../components/Preloader';
import { SearchResultPlug } from '../../components/SearchResultPlug';

export function SearchResultContainer() {
  const builders = useSelector(selectBuilders);
  const loading = useSelector(selectLoading);

  return (
    <SearchResultList loader={loading && <Preloader size={40} />} plug={!builders.length && <SearchResultPlug />}>
      {builders.map(builder => (
        <SearchResultItemContainer key={builder.id} builder={builder} />
      ))}
    </SearchResultList>
  );
}
